import { Button, Empty, Popconfirm, Space, Spin, Table, Typography } from 'antd';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../app/store';
import { Link } from 'react-router-dom';
import { getRoleDatas } from './slice';
import rolesAdmin from '../../../../apis/admin/rolesService';
import notificationHandler from '../../../atoms/Notification';
import { DeleteOutlined, FormOutlined, LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import './roles.scss'
import { adminRoles } from '../../../../configs/constant'

const ListRoles = () => {
    const { roles }: any = useSelector((state: RootState) => state.rolesList)
    const [loading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState<any>(0);

    const handlePageChange = (page: any, pageSize: any) => {
        setPageSize(pageSize)
        setCurrentPage(page);

    };

    const displayedIndex = (index: any) => (currentPage - 1) * pageSize + index + 1;

    const dispatch = useDispatch<AppDispatch>()

    const antIcon = <LoadingOutlined style={{ fontSize: 70, position: 'fixed' }} spin />;

    const { Title } = Typography;

    useEffect(() => {
        setLoading(true)
        dispatch(getRoleDatas()).then().catch().finally(() => setLoading(false))
    }, [dispatch])
    const confirm = (id: number) => {
        setLoading(true);
        rolesAdmin.removeRoles(id).then(() => {
            dispatch(getRoleDatas())
            notificationHandler('success', 'Xóa quyền thành công!')
            setLoading(false);
        }).catch((err) => {
            notificationHandler('error', err.response.data.data.msg_content)
            setLoading(false);
        })
    };
    const paginationConfig = {
        showTotal: (total: any, range: any) => `${range[0]}-${range[1]} Tổng ${total} bản ghi`
    };
    const columns: any = [
        {
            title: 'STT',
            dataIndex: 'index',
            key: 'index',
            width: '8%',
            align: 'center',
            render: (_: any, __: any, index: any) => displayedIndex(index),
        },
        {
            title: 'Quyền',
            dataIndex: 'roleName',
            width: '50%',
            align: 'center',
            key: 'roleName',
            render: (roleName: string) => {
                return <div className='truncates mx-auto' title={roleName}>
                    {roleName}
                </div>
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'address',
            width: '10%',
            align: 'center',
            render: (text: string, record: any) => {
                return (
                    <div className='w-full'>
                        {adminRoles.includes(record.roleName.toLowerCase()) ? '' : (
                            <Space size="small">
                                <Button className='mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white '><Link to={`/admin/editRoles/${record.id}`} className='flex items-center'><FormOutlined className='mr-1' />Sửa</Link></Button>
                                <Popconfirm
                                    title="Bạn có muốn xóa quyền này không?"
                                    onConfirm={() => confirm(record.id)}
                                    okText="Đồng ý"
                                    cancelText="Hủy"
                                    okType='danger'
                                >
                                    <Button danger className='bg-[#ff4d4f] text-white ' loading={loading}><div className='flex items-center'><DeleteOutlined className='pr-1' />Xóa</div></Button>
                                </Popconfirm>
                            </Space>
                        )}
                    </div>
                )
            }
        },
    ];

    return (
        <div id='roles'>
            <Spin indicator={antIcon} spinning={loading} />
            <div className='float-right'>
                <Button type='primary' className='p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text mb-4 rounded-sm'><Link to={'/admin/createRoles'} className='flex items-center'><PlusCircleOutlined className='mr-1' /> Thêm mới</Link></Button>
            </div>
            <Title className='mt-[15px]' level={3}>Danh sách quyền tài khoản</Title>
            <Table dataSource={roles} columns={columns} pagination={{
                locale: { items_per_page: 'bản ghi / Trang' },
                current: currentPage,
                defaultPageSize: 10, showSizeChanger: true, onChange: handlePageChange, pageSizeOptions: ['10', '20', '50'], showTotal: (total: any, range: any) => `${range[0]}-${range[1]} Tổng ${total} bản ghi`
            }} rowKey={(record: any) => record.id} 
            locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description="Không có dữ liệu!" /> }}
            />
        </div>
    )
}

export default ListRoles
